import wizardContent from "./extWizardContent.json";

export default function () {
	const isLocalhost = window.location.hostname.endsWith("localhost");

	if (isLocalhost) {
		return wizardContent;
	}
	return wizardContent;
}
